"use client"

export const FasHero = () => {
  return (
    <section className="relative bg-white border-b-8 border-orange-500 pt-24 pb-8 animate-in fade-in duration-700">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:py-16">
        <div className="text-center border-b-4 border-gray-900 pb-8 mb-12 animate-in slide-in-from-top duration-700">
          <div className="inline-flex items-center justify-center mb-6">
            <img 
              src="/FAS.jpg" 
              alt="Fly and Share Program" 
              className="h-40 sm:h-52 md:h-64 w-auto object-contain hover:scale-105 transition-transform duration-300" 
              loading="lazy"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-1 gap-8 lg:gap-10">
          <div className="border-l-4 border-orange-500 pl-6 animate-in slide-in-from-left duration-700" style={{ animationDelay: '200ms' }}>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-4">
              Transforming Education Through Essential Resources
            </h2>
            <p className="text-lg md:text-xl leading-relaxed text-gray-700 mb-6 text-justify">
              <span className="font-bold text-3xl float-left mr-0.5 leading-none text-orange-500">F</span>
              ly and Share is a non-profit organization dedicated to transforming education by providing essential
              learning tools and resources to students in need. Our mission is rooted in the belief that every student
              should have equal access to quality education and the necessary materials that empower them to succeed.
            </p>
            <p className="text-lg md:text-xl leading-relaxed text-gray-700 mb-6 text-justify">
              We strive to bridge the educational gap by supplying notebooks, stationery, digital devices, toiletries,
              and other educational resources to disadvantaged students across communities.
            </p>
            <p className="text-lg md:text-xl leading-relaxed text-gray-700 mb-6 text-justify">
              Our goal is to foster a conducive learning environment where students can thrive academically and realize
              their full potential.
            </p>
          </div>

          <div className="flex flex-col items-center justify-center animate-in slide-in-from-right duration-700" style={{ animationDelay: '400ms' }}>
          </div>
        </div>
      </div>
    </section>
  )
}
